export default function UsageCurrencySwitch({
  currency,
  onChange,
  rateState,
  language,
}) {
  const zh = language === "zh";
  const {
    data: exchangeRate,
    loading: rateLoading,
    error: rateError,
    refresh: refreshRate,
  } = rateState;

  return (
    <div className="rounded-xl bg-gray-50 dark:bg-gray-900/30 px-3 py-3">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs font-medium text-gray-600 dark:text-gray-300">
          {zh ? "顯示幣別" : "Display currency"}
        </p>
        <div
          role="group"
          aria-label={zh ? "顯示幣別" : "Display currency"}
          className="inline-flex rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 p-1"
        >
          {["USD", "TWD"].map((code) => (
            <button
              key={code}
              type="button"
              onClick={() => onChange(code)}
              aria-pressed={currency === code}
              disabled={code === "TWD" && !exchangeRate}
              className={`rounded-md px-3 py-1.5 text-xs font-semibold transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-orange-500 disabled:opacity-40 disabled:cursor-not-allowed ${
                currency === code
                  ? "bg-orange-500 text-white shadow-sm"
                  : "text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
              }`}
            >
              {code}
            </button>
          ))}
        </div>
      </div>
      <div
        role="status"
        className="mt-2 space-y-1 text-xs text-gray-500 dark:text-gray-400"
      >
        {exchangeRate && (
          <p>
            1 USD ≈ {exchangeRate.rate.toLocaleString(zh ? "zh-TW" : "en-US", {
              maximumFractionDigits: 4,
            })} TWD
            {" · "}
            {zh ? "匯率日期：" : "Rate as of "}{exchangeRate.date}
            {" · "}
            <a
              href="https://frankfurter.dev/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-gray-700 dark:hover:text-gray-200"
            >
              Frankfurter
            </a>
          </p>
        )}
        {currency === "TWD" && (
          <p>
            {zh
              ? "新臺幣金額僅供參考；歷史用量也以此匯率換算。"
              : "TWD amounts are estimates; past weeks use this same rate."}
          </p>
        )}
        {rateLoading && (
          <p>{zh ? "正在更新匯率…" : "Updating exchange rate…"}</p>
        )}
        {rateError && (
          <p>
            {exchangeRate
              ? zh
                ? "無法更新匯率，目前使用上方日期的快取匯率。"
                : "Couldn't refresh the rate. Using the cached rate dated above."
              : zh
                ? "暫時無法取得新臺幣匯率，仍可查看美元金額。"
                : "TWD conversion is unavailable. USD amounts are still available."}
            {" "}
            <button
              type="button"
              onClick={refreshRate}
              disabled={rateLoading}
              className="font-medium underline disabled:opacity-50"
            >
              {zh ? "重試匯率" : "Retry exchange rate"}
            </button>
          </p>
        )}
      </div>
    </div>
  );
}
